import * as THREE from "three";
import App from "./App";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { gsap } from "gsap";
var Camera = /** @class */ (function () {
    function Camera() {
        this.app = new App();
        this.sizes = this.app.sizes;
        this.scene = this.app.scene;
        this.canvas = this.app.canvas;
        this.setInstance();
        this.setControls();
        //this.runInitialAnimation();
    }
    Camera.prototype.setInstance = function () {
        this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 100);
        this.instance.position.set(0, 10, 10);
        this.scene.add(this.instance);
    };
    Camera.prototype.runInitialAnimation = function () {
        gsap.to(this.instance.position, {
            duration: 1,
            z: 0,
        });
    };
    Camera.prototype.setControls = function () {
        this.controls = new OrbitControls(this.instance, this.canvas);
        this.controls.maxPolarAngle = Math.PI / 2 - 0.05;
        this.controls.enableDamping = true;
    };
    Camera.prototype.resize = function () {
        this.instance.aspect = this.sizes.width / this.sizes.height;
        this.instance.updateProjectionMatrix();
    };
    Camera.prototype.update = function () {
        this.controls.update();
    };
    return Camera;
}());
export default Camera;
